import { render } from "./CreateShortListForm.vue?vue&type=template&id=218cd703"
import script from "./CreateShortListForm.vue?vue&type=script&lang=js"
export * from "./CreateShortListForm.vue?vue&type=script&lang=js"

import exportComponent from "/home/misha/Рабочий стол/kolos-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__